import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/Navigation/NavBar";

function TermsPage() {
  return (
    <>
      <NavBar />
      <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800">
        <h1 className="text-3xl font-bold text-center mb-6">Terms of Service</h1>
        <p className="text-center text-sm text-gray-500 mb-10">
          Last Updated: 09 July 2023
        </p>

        <Section title="1. General">
          <p>
            These Terms of Service apply to all users of the Services provided by NextLoop, including individuals or entities acting as landlords, tenants, business owners, or corporate users. If you’re using the Services on behalf of a business entity, "you" refers to that entity.
          </p>
          <p>
            “NextLoop” refers collectively to NextLoop Pte Ltd and its subsidiaries. By using our Services, you agree to abide by these Terms and any associated policies.
          </p>
          <p>
            We reserve the right to modify these Terms at any time. Continued use after updates constitutes acceptance of the revised Terms.
          </p>
        </Section>

        <Section title="2. Use of the Service">
          <p>
            NextLoop grants you a limited, non-exclusive, non-transferable, and revocable license to use the Services, provided you do not:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>Upload content that infringes on intellectual property or other rights.</li>
            <li>Reverse engineer, decompile, or disrupt the integrity of the Services.</li>
            <li>Use the Services for illegal or competing purposes.</li>
            <li>Send spam or upload malicious software.</li>
            <li>Use bots, scrapers, or automation to access the Services.</li>
            <li>Abuse promotions or attempt to exploit the platform.</li>
          </ul>
          <p>
            Violation of these terms may lead to suspension or termination of your account.
          </p>
        </Section>

        <Section title="3. Account">
          <p>
            You must create an account to access some parts of the Services. By creating an account, you confirm that:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>You’re at least 18 years old, or using with a guardian’s supervision.</li>
            <li>All information provided is accurate and up to date.</li>
            <li>You are responsible for all activity under your account.</li>
            <li>You will maintain account security and follow all applicable laws.</li>
          </ul>
          <p>
            Unauthorized use or multiple accounts may result in termination without notice.
          </p>
        </Section>

        <Section title="3.1 NextLoop Subscriptions">
          <p>
            You may claim or purchase subscriptions for premium features. Subscription terms, pricing, and rules are outlined within our official policy documents.
          </p>
        </Section>

        <Section title="4. Boast Campaigns">
          <p>
            Boast products improve your listing visibility. By using them, you accept:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>Priority may vary based on platform algorithms.</li>
            <li>No refunds for early termination or account suspension.</li>
            <li>No guarantee of user engagement or transactions.</li>
          </ul>
        </Section>

        <Section title="5. Fees and Payment">
          <p>
            Charges may include subscription fees, listing fees, and other applicable charges. Payment obligations include:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-2">
            <li>Ensuring timely and cleared payments.</li>
            <li>Understanding that most payments are non-refundable.</li>
            <li>Paying late fees (1.5% monthly or max allowed by law) if overdue.</li>
          </ul>
          <p>
            Failure to pay may lead to suspension or legal action.
          </p>
        </Section>

        <Section title="5.1 Listing Fees & Quotas">
          <p>
            Active listing limits may apply. Exceeding quotas will incur fees as outlined in our listing policies. Payments do not guarantee user actions or outcomes.
          </p>
        </Section>

        <Section title="6. Content">
          <p>
            You retain ownership of content shared via the Services. However, you grant NextLoop a global, royalty-free license to use your content to operate and improve our Services, in accordance with our Privacy Policy.
          </p>
        </Section>
      </div>
      <Footer />
    </>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-10">
      <h2 className="text-l font-semibold mb-3">{title}</h2>
      <div className="space-y-4 text-justify text-sm leading-relaxed">{children}</div>
    </div>
  );
}

export default TermsPage;
